export const STAGE = "prod"
export const version = "12.2.0"